import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class AudioService {
  private audioType = 'html5';
  private sounds: any[] = [];

  constructor() {
    // still detect native, but we'll use HTML5 on native too (avoid plugin)
    this.audioType = 'html5';
    // if you want special native handling later, toggle here
    if (Capacitor.isNativePlatform() && false) {
      this.audioType = 'native';
    }
  }

  preload(key: string, asset: string) {
    // create a preloaded HTMLAudio element and store it
    const audioEl = new Audio(asset);
    audioEl.preload = 'auto';
    audioEl.volume = 0.3;

    this.sounds.push({
      key,
      asset,
      type: 'html5',
      htmlAudio: audioEl,
    });
  }

  async play(key: string) {
    const audio = this.sounds.find(s => s.key === key);
    if (!audio) return;

    if (audio.type === 'html5') {
      // use existing element if preloaded
      if (audio.htmlAudio) {
        try {
          await audio.htmlAudio.play();
        } catch (e) {
          // autoplay/user interaction restrictions — fall back to creating one
          const a = new Audio(audio.asset);
          a.volume = 0.3;
          a.play().catch(() => {});
        }
      } else {
        const a = new Audio(audio.asset);
        a.volume = 0.3;
        a.play().catch(() => {});
      }
    } else {
      // (if you later enable native) call native plugin here
    }
  }
}
